const $inject = ['$rootScope', '$scope', '$routeParams', '$timeout', 'dataService'];

const lbaTextInputCtrl = function ($rootScope, $scope, $routeParams, $timeout, dataService) {
  const vm = this;
  const dataLookUp = dataService.spiltDataAt(vm.settings.dataAt, $routeParams);

  vm.data = _.get(dataService.data.activeItem, dataLookUp);
  vm.inputType = vm.settings.inputType || 'text';
  vm.min = vm.settings.min || 0;
  vm.max = vm.settings.max || 10000000000;
  vm.minLength = vm.settings.minLength|| 0;
  vm.maxLength = vm.settings.maxLength|| 10000000000;
  vm.validateEmail = vm.settings.validateEmail;
  vm.disabled = false;

  const EMAIL_REGEXP = /^[_a-z0-9]+(\.[_a-z0-9]+)*@[a-z0-9-]+(\.[a-z0-9-]+)*(\.[a-z]{2,4})$/;
  vm.pattern = vm.settings.validateEmail ? EMAIL_REGEXP : '';

  $scope.$watchCollection('vm.data', (newData, oldData) => {
    if (newData !== oldData) {
      _.set(dataService.data.activeItem, dataLookUp, newData)
    }
  });

  $rootScope.$on(vm.settings.dataAt, () => {
    $timeout(() => {
      vm.data = _.get(dataService.data.activeItem, dataLookUp);
    })
  });

  $rootScope.$on('disableSwitch', (event, data) => {
    if (vm.settings.dataAt === data.lookUp) {
        vm.disabled = !data.value;
        if (!data.value) {
          if (vm.inputType === 'number')
            _.set(dataService.data.activeItem, dataLookUp, 0);
          else 
            _.set(dataService.data.activeItem, dataLookUp, null);

            vm.data = _.get(dataService.data.activeItem, dataLookUp);
        }
    }
});
};

lbaTextInputCtrl.$inject = $inject;

export default lbaTextInputCtrl;


// WEBPACK FOOTER //
// ./src/components/lbaTextInput/lbaTextInputCtrl.js